// extracted by mini-css-extract-plugin
export default {"wrapper":"logged-out_wrapper__V+FFd"};